import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '../../../theme/scalingTokens';

export const useNavLinksStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalXS),
    [mq.mobile]: {
      display: 'none',
    },
  },
  link: {
    textDecoration: 'none',
    color: tokens.colorNeutralForegroundOnBrand,
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightRegular,
    ...shorthands.padding(tokens.spacingVerticalXS, tokens.spacingHorizontalS),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    whiteSpace: 'nowrap',
    minHeight: '2.75rem',
    display: 'flex',
    alignItems: 'center',
    ':hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
  },
  activeLink: {
    fontWeight: tokens.fontWeightSemibold,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
});
